<template>
  <div class="campaign-child">
    <Content
      class="campaign-content"
      :content="campaign.content_alt.content"
      v-if="campaign.content_alt && campaign.content_alt.content.length > 0"
    ></Content>

    <div class="campaign-content" v-html="campaign.content.rendered" v-else></div>
  </div>
</template>

<script>
import Content from '@/components/Utils/Content.vue'

export default {
  name: 'CampaignInfo',

  components: { Content },

  computed: {
    campaign () {
      return this.$route.name === 'campaign-info'
        ? this.$store.getters.campaign
        : this.$store.getters.ncCampaign
    }
  }
}
</script>
